import React from 'react';
import TituloEscritoriosEscolares from '../components/sections/EscritoriosEscolares/TituloEscritoriosEscolares'; 
import EscritoriosEscolaresIntro from '../components/sections/EscritoriosEscolares/EscritoriosEscolaresIntro'; 
import FormularioContactoEscritorios from '../components/sections/EscritoriosEscolares/FormularioContactoEscritorios'; 
import Header from '../components/layouts/Header';  
import Footer from '../components/layouts/Footer';

const EscritoriosEscolares = () => {
  return (
    <div>
      <Header />
        <TituloEscritoriosEscolares />     
        <EscritoriosEscolaresIntro /> 
        <FormularioContactoEscritorios /> 
      <Footer /> 
    </div>
  );
};

export default EscritoriosEscolares;